import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  SeoFaqContentComponent,
  CustomSeoContentComponent,
  AdvisoryContentTitleComponent,
  AdvisoryContentDescriptionComponent,
  OtherContentComponent,
  RichContentComponent,
} from './components';

import { SEO_FEATURE_NAME, reducers, PlpSeoEffects } from './store';
import { MmIconModule, MmFlexLayoutModule } from '@metromarkets/components';
import { MmExpansionModule } from '~shared/modules/mm-expansion/mm-expansion.module';
import { BasePageModule } from '~shared/modules/base-page/base-page.module';
import { NewsletterSubscriptionModule } from '~shared/modules/newsletter-subscription/newsletter-subscription.module';
import { FlexModule } from '@angular/flex-layout';
import { SanitizeModule } from '~shared/pipes/sanitaze/sanitaze.module';
import { ImageHeaderModule } from '~shared/components/image-header/image-header.module';
import { ChevronRightModule } from '~shared/svgs/chevron-right/chevron-right.module';

@NgModule({
  declarations: [
    SeoFaqContentComponent,
    CustomSeoContentComponent,
    AdvisoryContentTitleComponent,
    AdvisoryContentDescriptionComponent,
    OtherContentComponent,
    RichContentComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    RouterModule,
    MmIconModule,
    MmExpansionModule,
    MmFlexLayoutModule,
    FlexModule,
    BasePageModule,
    NewsletterSubscriptionModule,
    ImageHeaderModule,
    StoreModule.forFeature(SEO_FEATURE_NAME, reducers),
    EffectsModule.forFeature([PlpSeoEffects]),
    SanitizeModule,
    ChevronRightModule
  ],
  exports: [
    SeoFaqContentComponent,
    CustomSeoContentComponent,
    RichContentComponent,
  ],
})
export class SeoModule {}
